/**
 * Load the comparatively large variant picker only on pages that need it.
 * Product cards keep a tiny click bridge in the main bundle so the first
 * interaction still opens the picker normally.
 */
(function() {
	const SCRIPT_PATH = "/assets/aracwebshop/js/variant_picker.js";
	const SCRIPT_VERSION = "variant-list-scroll-1";
	const LOADING_SHELL_ID = "arac-variant-picker-loading-shell";
	const LOADING_STYLES_ID = "arac-variant-picker-loading-styles";
	let loadPromise = null;
	let openRequestId = 0;

	function ensureLoadingStyles() {
		if (document.getElementById(LOADING_STYLES_ID)) return;

		const style = document.createElement("style");
		style.id = LOADING_STYLES_ID;
		style.textContent = `
			body.arac-variant-picker-loading-open {
				overflow: hidden;
				overscroll-behavior: none;
			}

			.arac-vp-loading-shell-overlay {
				position: fixed;
				inset: 0;
				z-index: 2147482501;
				display: flex;
				align-items: flex-end;
				justify-content: center;
				padding: 8px;
				background: rgba(15, 23, 42, 0.58);
				backdrop-filter: blur(12px) saturate(110%);
				-webkit-backdrop-filter: blur(12px) saturate(110%);
				opacity: 0;
				transition: opacity 160ms ease;
			}

			.arac-vp-loading-shell-overlay.is-visible { opacity: 1; }

			.arac-vp-loading-shell-dialog {
				position: relative;
				width: 100%;
				max-height: calc(100dvh - 16px);
				overflow: hidden;
				border: 1px solid rgba(15, 23, 42, 0.14);
				border-radius: 20px 20px 0 0;
				background: #fff;
				box-shadow: 0 26px 70px rgba(15, 23, 42, 0.22);
			}

			.arac-vp-loading-shell-close {
				position: absolute;
				top: 12px;
				right: 12px;
				z-index: 2;
				width: 36px;
				height: 36px;
				border: 0;
				border-radius: 999px;
				background: rgba(255, 255, 255, 0.92);
				color: #334155;
				font-size: 24px;
				line-height: 32px;
				box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
			}

			.arac-vp-loading-shell-media {
				display: flex;
				align-items: center;
				justify-content: center;
				min-height: 168px;
				padding: 14px;
				border-bottom: 1px solid rgba(15, 23, 42, 0.1);
				background: #f8fafc;
			}

			.arac-vp-loading-shell-body { padding: 20px 16px 14px; }

			.arac-vp-loading-shell-shimmer {
				position: relative;
				overflow: hidden;
				background: #e8edf4;
			}

			.arac-vp-loading-shell-shimmer::after {
				content: "";
				position: absolute;
				inset: 0;
				transform: translateX(-100%);
				background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.74), transparent);
				animation: arac-vp-loading-shell-shimmer 1.25s infinite;
			}

			.arac-vp-loading-shell-image {
				width: min(330px, 100%);
				aspect-ratio: 16 / 9;
				border-radius: 14px;
			}

			.arac-vp-loading-shell-pill {
				width: 86px;
				height: 22px;
				border-radius: 999px;
			}

			.arac-vp-loading-shell-title {
				width: min(72%, 360px);
				height: 26px;
				margin: 14px 0 18px;
				border-radius: 8px;
			}

			.arac-vp-loading-shell-row {
				display: grid;
				grid-template-columns: 46px minmax(0, 1fr) 42px;
				align-items: center;
				gap: 10px;
				min-height: 58px;
				border-top: 1px solid rgba(15, 23, 42, 0.08);
			}

			.arac-vp-loading-shell-thumb {
				width: 42px;
				height: 42px;
				border-radius: 9px;
			}

			.arac-vp-loading-shell-copy { display: grid; gap: 7px; }
			.arac-vp-loading-shell-line { height: 10px; border-radius: 999px; }
			.arac-vp-loading-shell-action { width: 38px; height: 34px; border-radius: 9px; }

			@keyframes arac-vp-loading-shell-shimmer {
				100% { transform: translateX(100%); }
			}

			@media (min-width: 901px) {
				.arac-vp-loading-shell-overlay { align-items: center; padding: 32px; }
				.arac-vp-loading-shell-dialog {
					display: grid;
					grid-template-columns: minmax(310px, 42%) minmax(0, 1fr);
					width: min(1080px, calc(100vw - 48px));
					min-height: 510px;
					border-radius: 20px;
				}
				.arac-vp-loading-shell-media {
					min-height: 510px;
					border-right: 1px solid rgba(15, 23, 42, 0.1);
					border-bottom: 0;
					padding: 28px;
				}
				.arac-vp-loading-shell-image { width: min(100%, 430px); aspect-ratio: 1 / 1; }
				.arac-vp-loading-shell-body { padding: 32px 30px; }
			}

			@media (prefers-color-scheme: dark) {
				.arac-vp-loading-shell-dialog { background: #101216; border-color: rgba(226, 232, 240, 0.18); }
				.arac-vp-loading-shell-media { background: #0c0e12; border-color: rgba(226, 232, 240, 0.13); }
				.arac-vp-loading-shell-row { border-color: rgba(226, 232, 240, 0.1); }
				.arac-vp-loading-shell-shimmer { background: #1b1f27; }
				.arac-vp-loading-shell-shimmer::after {
					background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.08), transparent);
				}
			}
		`;
		document.head.appendChild(style);
	}

	function loadingRow(width) {
		return `
			<div class="arac-vp-loading-shell-row">
				<span class="arac-vp-loading-shell-shimmer arac-vp-loading-shell-thumb"></span>
				<span class="arac-vp-loading-shell-copy">
					<span class="arac-vp-loading-shell-shimmer arac-vp-loading-shell-line" style="width: ${width};"></span>
					<span class="arac-vp-loading-shell-shimmer arac-vp-loading-shell-line" style="width: 42%;"></span>
				</span>
				<span class="arac-vp-loading-shell-shimmer arac-vp-loading-shell-action"></span>
			</div>
		`;
	}

	function showLoadingShell() {
		ensureLoadingStyles();
		hideLoadingShell(true);

		const overlay = document.createElement("div");
		overlay.id = LOADING_SHELL_ID;
		overlay.className = "arac-vp-loading-shell-overlay";
		overlay.innerHTML = `
			<div class="arac-vp-loading-shell-dialog" role="dialog" aria-modal="true" aria-label="Loading variants">
				<button type="button" class="arac-vp-loading-shell-close" data-arac-variant-loading-close aria-label="Close">&times;</button>
				<div class="arac-vp-loading-shell-media">
					<div class="arac-vp-loading-shell-shimmer arac-vp-loading-shell-image"></div>
				</div>
				<div class="arac-vp-loading-shell-body">
					<div class="arac-vp-loading-shell-shimmer arac-vp-loading-shell-pill"></div>
					<div class="arac-vp-loading-shell-shimmer arac-vp-loading-shell-title"></div>
					${loadingRow("72%")}
					${loadingRow("62%")}
					${loadingRow("68%")}
				</div>
			</div>
		`;
		document.body.appendChild(overlay);
		document.body.classList.add("arac-variant-picker-loading-open");
		window.requestAnimationFrame(() => overlay.classList.add("is-visible"));
	}

	function hideLoadingShell(immediate=false) {
		const overlay = document.getElementById(LOADING_SHELL_ID);
		document.body.classList.remove("arac-variant-picker-loading-open");
		if (!overlay) return;
		if (immediate) {
			overlay.remove();
			return;
		}
		overlay.classList.remove("is-visible");
		window.setTimeout(() => overlay.remove(), 160);
	}

	function getScriptSrc() {
		const mainBundle = document.querySelector('script[src*="/aracwebshop-web.bundle."]');
		const mainHash = mainBundle && (mainBundle.getAttribute("src") || "").match(/bundle\.([A-Z0-9]+)\.js/i);
		const version = window._version_number || (mainHash && mainHash[1]) || "1";
		return `${SCRIPT_PATH}?v=${encodeURIComponent(`${version}-${SCRIPT_VERSION}`)}`;
	}

	function getPicker() {
		return window.aracwebshop &&
			aracwebshop.aracwebshop &&
			aracwebshop.aracwebshop.variant_picker;
	}

	function initializePicker() {
		const picker = getPicker();
		if (!picker || typeof picker.init !== "function") {
			throw new Error("Variant picker did not initialize");
		}
		picker.init();
		return picker;
	}

	function loadVariantPicker() {
		const existingPicker = getPicker();
		if (existingPicker && typeof existingPicker.init === "function") {
			existingPicker.init();
			return Promise.resolve(existingPicker);
		}

		if (loadPromise) return loadPromise;

		loadPromise = new Promise((resolve, reject) => {
			const scriptSrc = getScriptSrc();
			let script = document.querySelector("script[data-arac-variant-picker-src]");
			let shouldAppend = false;
			if (!script) {
				script = document.createElement("script");
				script.src = scriptSrc;
				script.async = true;
				script.setAttribute("data-arac-variant-picker-src", SCRIPT_PATH);
				shouldAppend = true;
			}

			const onLoad = () => {
				cleanup();
				try {
					resolve(initializePicker());
				} catch (error) {
					reject(error);
				}
			};
			const onError = () => {
				cleanup();
				reject(new Error("Unable to load variant picker"));
			};
			const cleanup = () => {
				script.removeEventListener("load", onLoad);
				script.removeEventListener("error", onError);
			};

			script.addEventListener("load", onLoad, { once: true });
			script.addEventListener("error", onError, { once: true });
			if (shouldAppend) document.head.appendChild(script);
		}).catch((error) => {
			loadPromise = null;
			throw error;
		});

		return loadPromise;
	}

	function pageNeedsVariantPicker(root) {
		const scope = root && root.querySelector ? root : document;
		return !!scope.querySelector(
			".arac-product-variant-table-shell[data-item-code], .btn-explore-variants"
		);
	}

	function ensureVariantPickerForPage(root) {
		if (!pageNeedsVariantPicker(root)) return Promise.resolve(null);

		const load = () => loadVariantPicker().catch((error) => {
			console.warn("[Arac] Variant picker lazy-load failed", error);
			return null;
		});

		if (typeof window.requestIdleCallback === "function") {
			return new Promise((resolve) => {
				window.requestIdleCallback(() => load().then(resolve), { timeout: 350 });
			});
		}

		return new Promise((resolve) => {
			window.setTimeout(() => load().then(resolve), 0);
		});
	}

	function normalizeRoute(route) {
		if (!route) return null;
		return String(route).startsWith("/") ? String(route) : `/${route}`;
	}

	window.aracLoadVariantPicker = loadVariantPicker;
	window.aracEnsureVariantPickerForPage = ensureVariantPickerForPage;

	$(document)
		.off("click.arac_variant_picker_loader", ".btn-explore-variants")
		.on("click.arac_variant_picker_loader", ".btn-explore-variants", function(event) {
			event.preventDefault();
			event.stopImmediatePropagation();

			const $button = $(this);
			const $card = $button.closest(".item-card");
			const itemCode = $button.data("item-code") || $card.data("item-code");
			const route = $button.data("route") || $card.data("route") || $button.closest("a").attr("href");
			const requestId = ++openRequestId;

			$button.attr("aria-busy", "true");
			showLoadingShell();
			loadVariantPicker()
				.then((picker) => {
					if (requestId !== openRequestId) return;
					picker.open(itemCode, route);
					window.requestAnimationFrame(() => hideLoadingShell(true));
				})
				.catch((error) => {
					if (requestId !== openRequestId) return;
					hideLoadingShell();
					console.warn("[Arac] Variant picker lazy-load failed", error);
					const fallbackRoute = normalizeRoute(route);
					if (fallbackRoute) window.location.href = fallbackRoute;
				})
				.finally(() => $button.removeAttr("aria-busy"));
		});

	$(document)
		.off("click.arac_variant_picker_loading_close", "[data-arac-variant-loading-close]")
		.on("click.arac_variant_picker_loading_close", "[data-arac-variant-loading-close]", function(event) {
			event.preventDefault();
			++openRequestId;
			hideLoadingShell();
		});

	$(document)
		.off("click.arac_variant_picker_loading_backdrop", ".arac-vp-loading-shell-overlay")
		.on("click.arac_variant_picker_loading_backdrop", ".arac-vp-loading-shell-overlay", function(event) {
			if (event.target !== event.currentTarget) return;
			++openRequestId;
			hideLoadingShell();
		});

	// Card navigation used to live inside variant_picker.js. Keep the small
	// handler eager so lazy-loading the picker does not change card behavior.
	$(document)
		.off("click.arac_item_card_nav", ".item-card[data-route]")
		.on("click.arac_item_card_nav", ".item-card[data-route]", function(event) {
			if ($(event.target).closest("a, button, input, select, textarea, label, .cart-btn-overlay-container, .uom-chips-container, .uom-dropdown-wrapper").length) {
				return;
			}

			const route = normalizeRoute($(this).data("route"));
			if (!route) return;
			if (window.aracPjaxNavigate) {
				window.aracPjaxNavigate(route, { anchor: this });
			} else {
				window.location.href = route;
			}
		});

	frappe.ready(() => ensureVariantPickerForPage(document));
})();
